var exports = {
  "kL": "container__udsYfg",
  "iD": "login__aQxWMh",
  "SU": "muted__2wo0Vf",
  "_o": "sourceLink__wVc4Pj",
  "pI": "sourceIcon__4jupF0",
  "KJ": "teamsImage__2KsCNA",
};

module.exports = exports;
